import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LayoutDashboard, QrCode, Car, User, LogOut } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'
import { BottomNavigation } from '@progress/kendo-react-layout'

const navItems = [
  { text: 'Dashboard', href: '/customer', iconComponent: LayoutDashboard },
  { text: 'My QR', href: '/customer/qr', iconComponent: QrCode },
  { text: 'History', href: '/customer/history', iconComponent: Car },
  { text: 'Profile', href: '/customer/profile', iconComponent: User },
  { text: 'Logout', action: 'logout', iconComponent: LogOut },
]

export default function BottomNav() {
  const location = useLocation()
  const navigate = useNavigate()
  const { signOut } = useAuth()

  const items = useMemo(() => {
    return navItems.map((item) => {
      const selected =
        !!item.href &&
        (location.pathname === item.href || location.pathname.startsWith(item.href + '/'))

      return {
        ...item,
        selected,
        // Kendo expects `icon` to be a string. We render our own icon via `itemRender`.
        icon: '',
      }
    })
  }, [location.pathname])

  const handleSelect = async (e) => {
    const item = e.itemTarget
    // Some Kendo events expose the selected item as `itemTarget`, others as `item`.
    const resolvedItem = item || e.item
    if (resolvedItem?.action === 'logout') {
      try {
        await signOut()
      } catch (error) {
        console.error('Logout error:', error)
        toast.error('Failed to logout')
      }
      return
    }

    if (resolvedItem?.href) navigate(resolvedItem.href)
  }

  const itemRender = (defaultItem, itemProps) => {
    const { dataItem } = itemProps
    const Icon = dataItem?.iconComponent
    const isActive = !!dataItem?.selected
    const isLogout = dataItem?.action === 'logout'

    // IMPORTANT: Preserve Kendo's built-in event handlers by cloning `defaultItem`.
    return (
      <defaultItem.type {...defaultItem.props}>
        <span className="customer-bottom-nav__item">
          <span
            className={[
              'customer-bottom-nav__chip',
              isActive ? 'is-active' : '',
              isLogout ? 'is-logout' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {Icon ? (
              <Icon className="customer-bottom-nav__icon" strokeWidth={isActive ? 2.35 : 2} />
            ) : null}
          </span>
          <span className="customer-bottom-nav__label">{dataItem?.text}</span>
        </span>
      </defaultItem.type>
    )
  }

  return (
    <BottomNavigation
      className="customer-bottom-nav md:hidden"
      items={items}
      onSelect={handleSelect}
      itemRender={itemRender}
      border={false}
      positionMode="fixed"
    />
  )
}
